import { Component, OnInit, OnDestroy } from '@angular/core';
import { OAuthService, OAuthEvent } from 'angular-oauth2-oidc';
import { interval, Subscription, fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-session-timer',
  template: `
    <div
      class="timer"
      [ngClass]="{ warning: isWarning, expired: isExpired }"
    >
      {{ timeLeft }}
    </div>
  `,
  styles: [
    `
      .timer {
        position: fixed;
        bottom: 10px;
        right: 10px;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        padding: 5px 10px;
        border-radius: 5px;
        font-family: monospace;
        transition: background 0.3s;
      }
      .warning {
        background: orange;
      }
      .expired {
        background: red;
      }
    `,
  ],
})
export class SessionTimerComponent implements OnInit, OnDestroy {
  timeLeft = '';
  isWarning = false;
  isExpired = false;
  private tokenExpiration: number | null = null;
  private subscription = new Subscription();
  private WARNING_THRESHOLD = 2 * 60 * 1000; // 1 min

  constructor(private oauthService: OAuthService) {}

  ngOnInit() {
    this.setTokenExpiration();

    // React to token changes
    this.subscription.add(
      this.oauthService.events
        .pipe(filter((e: OAuthEvent) => e.type === 'token_received'))
        .subscribe(() => this.setTokenExpiration())
    );

    // Update every second based on real time
    this.subscription.add(
      interval(1000).subscribe(() => this.updateTimeLeft())
    );

    // Update immediately if tab becomes visible again
    this.subscription.add(
      fromEvent(document, 'visibilitychange').subscribe(() => {
        if (!document.hidden) {
          this.updateTimeLeft();
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private setTokenExpiration() {
    this.tokenExpiration = this.oauthService.getAccessTokenExpiration();
    this.updateTimeLeft();
  }

  private updateTimeLeft() {
    this.tokenExpiration = this.oauthService.getAccessTokenExpiration();
    if (!this.tokenExpiration) {
      this.timeLeft = 'Sitzung nicht verfügbar';
      this.isWarning = false;
      this.isExpired = false;
      return;
    }
    if ((this.oauthService as any).tokenEndpoint === undefined ||
      (this.oauthService as any).tokenEndpoint === null) {        
        this.trySilentRefresh();
    }
    

    const now = Date.now();
    const diff = this.tokenExpiration - now;

    if (diff <= 0) {
      this.timeLeft = 'Sitzung abgelaufen';
      this.isWarning = false;
      this.isExpired = true;
      this.logout();
    } else {
      this.isWarning = diff <= this.WARNING_THRESHOLD;
      this.isExpired = false;

      const minutes = Math.floor(diff / 1000 / 60);
      const seconds = Math.floor((diff / 1000) % 60);
      this.timeLeft = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

      // Optional: try silent refresh when in warning range
      if (this.isWarning) {
        this.trySilentRefresh();
      }
    }
  }

  private trySilentRefresh() {
    if (this.oauthService.tokenEndpoint === null) {
        this.oauthService.loadDiscoveryDocument().then(() => {
          
          this.oauthService.refreshToken().catch(() => {
            console.error('session timer: loadDiscoveryDocumentAndTryLogin failed');
          });
        }).catch((err) => {
          console.error(`session timer: refreshToken 1 failed: ${err}`, err);
          }
        );
    }else{
      this.oauthService.refreshToken().catch((err) => {
          console.error(`session timer: refreshToken 2 failed: ${err}`, err);
          });
    }
  }

  private logout() {
    // this.oauthService.logOut();
  }
}
